/* unplugin-vue-components disabled */import { render } from "./nopermission.vue?vue&type=template&id=5648fb8c&scoped=true"
import script from "./nopermission.vue?vue&type=script&lang=js"
export * from "./nopermission.vue?vue&type=script&lang=js"

import "./nopermission.vue?vue&type=style&index=0&id=5648fb8c&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5648fb8c"]])

export default __exports__